// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import TerceraBaseWindowTemplate from '@front/templates/TerceraBaseWindowTemplate.html';
import { Resources } from '@shared/localizations/Resources';
import { TerceraWindowBase } from './TerceraWindowBase';
import { ScreensNames } from '../UtilsClasses/FactoryConstants';
export class QRCodeScreen extends TerceraWindowBase {
    constructor() {
        super();
        this.handleLastSelectedItemUpdate = (item) => {
            const callback = this.get('onUpdateLastSelectedItemCallback');
            callback === null || callback === void 0 ? void 0 : callback(item);
        };
    }
    getType() {
        return ScreensNames.QRCodeScreen;
    }
    oncomplete() {
        super.oncomplete();
        this.localize();
    }
    localize() {
        void this.set({
            header: Resources.getResource('screen.QRCodeScreen.header')
        });
    }
}
TerceraWindowBase.extendWith(QRCodeScreen, {
    template: TerceraBaseWindowTemplate,
    data: function () {
        return {
            movable: false,
            showHeader: true,
            showFooter: false,
            resizable: false,
            canSelect: false,
            focused: true,
            isAutoClose: true,
            width: 350,
            qrCodeScreenItems: [],
            selectedItemId: '',
            onUpdateLastSelectedItemCallback: null
        };
    },
    partials: {
        bodyPartial: '<reactQRCodeScreen on-onUpdateLastSelectedItem="@this.handleLastSelectedItemUpdate($1)" items="{{qrCodeScreenItems}}" selectedItemId="{{selectedItemId}}" />'
    }
});
